export default __webpack_public_path__ + "0e85a4932dd8edb44ce19b274239488b.png";